import { gql } from '@apollo/client';

const OFFER_FRAGMENT = gql`
  fragment OfferFragment on Offer {
    profile {
      id
      name
    }
    vehicle {
      id
      friendlyName
    }
    hasRequiredCerts
    certMap
    status
    message
    cancellationComment
    cancelledAfterAcceptedAt
    cancellationCategory
    rejectionReason
    acceptedAt
    timestamp
  }
`;
export const OfferFragments = [OFFER_FRAGMENT];
